import { render, staticRenderFns } from "./TransportRoutesShowDialog.vue?vue&type=template&id=06f080cd&scoped=true&"
import script from "./TransportRoutesShowDialog.vue?vue&type=script&lang=js&"
export * from "./TransportRoutesShowDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f080cd",
  null
  
)

export default component.exports